export class BetModel {
    constructor(source) {
        this.id = source.id;
    }
}
//# sourceMappingURL=BetModel.js.map